import React, { useState } from "react";
import Link from "../link";
import Modal from "../modal";
import Markup from "../markup";

const ModalLink = ({ text, content, sx = {}, ...props }) => {
	const [active, setActive] = useState(false);

	return text && content ? (
		<>
			<Link
				as="button"
				color="text"
				fontSize={'8px'}
				p={0}
				m={0}
				sx={{ border: 'none', textTransform: '', fontWeight: '400', ...sx }}
				onClick={() => setActive(true)}
				{...props}
			>
				{text}
			</Link>
			<Modal isOpen={active} handleClose={() => void setActive(false)}>
				<Markup html={content.processed} maxWidth={[null, null, 600, 800]} />
			</Modal>
		</>
	) : null;
};

export default ModalLink;
